import VillaltaScore from "../../../../src/client/katnh/widgets/VillaltaScore.js";
import * as React from 'react';
export default {
  VillaltaScore,
  React
};